import React from 'react';
import { CTAButton } from './CTAButton';
import { BOX_IMAGE, CHECKOUT_URL, CTA_LABEL, GUARANTEE_LINE, heroIntro } from '../data/atlante';
export function Hero() {
  return <section className="bg-navy px-4 py-5 text-center sm:py-7" data-id="element-85" data-mp="9kjvumdkz02m">
      <div className="mx-auto max-w-3xl" data-id="element-86" data-mp="9ipax82b77yj">
        <h1 className="text-2xl leading-[0.98] text-white sm:text-4xl" data-id="element-87" data-mp="4m8m0bnacpke">
          IL SISTEMA VISIVO COMPLETO PER LA{' '}
          <span className="text-gold" data-id="element-88" data-mp="128frrovbsnyc">PROTESI DENTALE</span>
        </h1>

        {heroIntro.map(paragraph => <p key={paragraph} className="mx-auto mt-2 max-w-2xl text-[13px] font-medium leading-snug text-white/85 sm:text-[15px]" data-id="element-89" data-mp="xaxgvsxqzynp">
            {paragraph}
          </p>)}

        <a href={CHECKOUT_URL} className="mt-3 block" data-id="element-90" data-mp="nbydaoruat7k">
          <img src={BOX_IMAGE} alt="ATLANTE VISIVO DI PROTESI DENTALE™ — cofanetto completo 6-in-1" className="mx-auto w-full max-w-[280px] drop-shadow-2xl transition-transform duration-200 ease-soft hover:scale-[1.02] sm:max-w-sm" data-id="element-91" data-mp="3d1sakxd0hjt4" />
        </a>

        <CTAButton className="mx-auto mt-3 max-w-md" data-id="element-92" data-mp="3o858328mtl0c">{CTA_LABEL}</CTAButton>

        <p className="mt-2 text-[11px] font-bold text-gold sm:text-xs" data-id="element-93" data-mp="39acx8ne15ksh">
          {GUARANTEE_LINE}
        </p>
      </div>
    </section>;
}